export type Lang = 'zh' | 'en';

const DEFAULT_LANG: Lang = 'zh';
const ROOT_LABELS: Record<Lang, string> = {
  zh: '此电脑',
  en: 'This PC',
};

const translations = {
  zh: {
    rootLabel: '此电脑',
    quickAccess: '快速访问',
    unpinQuickAccess: '从快速访问取消固定',
    pinQuickAccess: '固定到快速访问',
    network: '网络',
    empty: '空',
    loading: '加载中...',
    noSubfolders: '无子文件夹',
    selectFolder: '选择文件夹',
    cancel: '取消',
    confirm: '确认',
    name: '名称',
    type: '类型',
    size: '大小',
    dateModified: '修改日期',
    diskUsage: '占磁盘',
    parentPercent: '占比',
    percentPendingInit: '待初始化',
    percentInitializing: '初始化中',
    fileCount: '文件数',
    na: '—',
    file: '文件',
    folder: '文件夹',
    drive: '驱动器',
    devicesAndDrives: '设备和驱动器',
    driveFree: '可用',
    driveTotal: '共',
    driveLoading: '正在获取...',
    fileFolder: '文件夹',
    movingItems: '正在移动 {count} 项',
    downloadFailed: '下载失败: {message}',
    downloadStart: '正在下载 {count} 个项目...',
    loadingFiles: '加载中 {loaded}/{total}',
    pathCopied: '路径已复制到剪贴板',
    linkCopied: '链接已复制到剪贴板',
    unzipFailed: '解压失败: {message}',
    extractSuccess: '已解压到：{path}',
    renameFailed: '重命名失败',
    // 文件分享
    shareTitle: '分享文件',
    shareFileCount: '已选 {count} 个文件',
    sharePassword: '提取密码',
    sharePasswordPlaceholder: '留空表示无需密码',
    shareMaxDownloads: '最大下载次数',
    shareMaxDownloadsPlaceholder: '留空表示不限制',
    shareExpiry: '有效期',
    shareExpiryDuration: '相对时长',
    shareExpiryDate: '到期日期',
    shareDurationValue: '时长',
    shareUnitHour: '小时',
    shareUnitDay: '天',
    shareSubmit: '生成分享链接',
    shareSubmitting: '生成中...',
    shareResultTitle: '分享链接已生成',
    shareLinkWithPassword: '带密码链接',
    shareLinkNoPassword: '不带密码链接',
    shareCopy: '复制',
    shareCopied: '已复制',
    shareCopyAll: '复制全部',
    shareDone: '完成',
    shareFailed: '分享失败: {message}',
    shareInvalidDuration: '请输入有效的时长',
    shareInvalidDate: '请选择有效的到期日期',
    pasteFailed: '粘贴失败',
    deleteConfirm: '删除 {count} 个项目？',
    deleteConfirmNonEmptySingle: '删除 {count} 个项目？\n\n注意：{names} 是非空文件夹，将连同其内容一起删除。',
    deleteConfirmNonEmptyMultiple: '删除 {count} 个项目？\n\n注意：{names} 是非空文件夹，将连同其内容一起删除。',
    deleteFailed: '删除失败 {count} 个项目：\n{details}',
    exceedsBatchLimit: '超过 10GB 限制',
    fileTooLarge: '文件过大（>2GB）',
    newFolder: '新建文件夹',
    extractTo: '解压到...',
    commandGlobalSearchTitle: '全局文件搜索 (Ctrl+Shift+F)',
    commandSearchAllFiles: '搜索全部文件',
    commandFilter: '筛选',
    commandRegex: '使用正则表达式',
    commandMatchCase: '区分大小写',
    commandMatchWholeWord: '整词匹配',
    commandGridView: '网格视图',
    commandDetailsView: '详情视图',
    commandTreemapView: '空间分析',
    spaceAnalysisTitle: '磁盘空间分析',
    spaceAnalysisNeedEngine: '需要文件索引就绪后才能分析空间占用',
    spaceAnalysisEmpty: '当前目录没有可显示的占用',
    spaceAnalysisLoading: '正在分析…',
    treemapOtherHint: '点击查看明细',
    contextLocateInRemote: '在远程桌面中定位',
    contextOpenInRemote: '在远程桌面中打开',
    contextRemoteLocateMultiConfirm: '将在远程桌面依次定位 {count} 个项目，确定继续吗？',
    contextRemoteOpenMultiConfirm: '将在远程桌面依次打开 {count} 个项目，确定继续吗？',
    treemapLocateInManager: '在文件管理中定位',
    treemapLocateInRemote: '在远程桌面中定位',
    treemapDelete: '删除',
    spaceListTitle: '{name} · 子项明细',
    spaceListSummary: '共 {count} 项 · {size}',
    spaceListMoreOmitted: '另有 {count} 项较小项（{size}）未在列表显示',
    fileCountCol: '{count} 文件',
    fileCountColHeader: '文件数',
    commandUploadFile: '上传文件',
    commandUploadFolder: '上传文件夹',
    commandUploadManager: '上传管理',
    commandOpenNewWindow: '新窗口打开',
    commandClose: '关闭',
    contextNewFolder: '新建文件夹',
    contextPaste: '粘贴',
    contextSortBy: '排序方式',
    contextSortName: '名称',
    contextSortType: '类型',
    contextSortSize: '大小',
    contextSortDate: '日期',
    contextSortAsc: '升序',
    contextSortDesc: '降序',
    contextDownloadZip: '打包下载',
    contextDownload: '下载',
    contextShare: '分享',
    contextPreview: '预览',
    contextEdit: '编辑',
    contextExtract: '解压...',
    contextExtractHere: '解压到当前目录',
    contextExtractTo: '解压到...',
    contextPin: '固定到快速访问',
    contextUnpin: '取消固定',
    contextRename: '重命名',
    contextCopy: '复制',
    contextCut: '剪切',
    contextCopyPath: '复制路径',
    contextDelete: '删除',
    contextUploadHere: '上传到此文件夹',
    contextUploadFile: '上传文件',
    contextUploadFolder: '上传文件夹',
    searchPlaceholder: '搜索全部文件...',
    searchMode: '模式：',
    searchPrefix: '前缀',
    searchContains: '包含',
    searchPrefixHint: '（更快，匹配开头）',
    initializedVolumes: '已索引：',
    searchContainsHint: '（较慢，任意位置匹配）',
    searchInitializing: '文件搜索引擎正在初始化中，请稍候...',
    searchContainsMinChars: 'Contains 模式需要至少 3 个字符',
    searchFailed: '搜索失败',
    searchInitializingHint: '首次启动需要扫描磁盘索引，请耐心等待...',
    searchNoResults: '没有找到结果',
    searchMinChars: '请输入至少 2 个字符进行搜索',
    searchGoToFolder: '打开所在文件夹',
    searchResultsCount: '{count} 条结果',
    searchResultsHint: '点击或回车跳转到所在目录',
    conflictTitle: '文件冲突',
    conflictMessage: '目标位置已存在名为 "{name}" 的文件。',
    conflictExisting: '已存在文件',
    conflictQuestion: '请选择操作',
    conflictReplace: '替换文件',
    conflictReplaceDesc: '用新文件覆盖现有文件',
    conflictRename: '重命名新文件',
    conflictRenameDesc: '保留两个文件（添加序号）',
    conflictSkip: '跳过该文件',
    conflictSkipDesc: '不复制/上传该文件',
    conflictApplyAll: '对所有冲突执行此操作',
    conflictOverwriteAll: '全部覆盖',
    conflictRenameAll: '全部重命名',
    conflictSkipAll: '全部跳过',
    uploadTitle: '上传',
    uploadCurrent: '当前',
    uploadHistory: '历史',
    uploadAllComplete: '全部上传完成',
    uploadNoHistory: '暂无历史',
    uploadClearHistory: '清空历史',
    uploadBatch: '批次 {id}',
    uploadRetryBatch: '重试批次',
    uploadCancelBatch: '取消批次',
    uploadMoreItems: '... 还有 {count} 项',
    uploadCancelTitle: '取消上传批次？',
    uploadCancelDesc: '是否删除已上传成功的文件？',
    uploadCancelYesDelete: '是，删除已上传文件',
    uploadCancelNoKeep: '否，保留已上传文件',
    uploadCancelContinue: '取消（继续上传）',
    previewHex: 'Hex',
    previewHead: '头部',
    previewTail: '尾部',
    previewMore: '更多 ({size})',
    previewLoading: '加载中...',
    previewFit: '适配',
    previewEncodingFallback: '编码回退',
    previewPartial: '部分',
    previewPartialTip: '预览不完整',
    previewToggleHex: '切换 Hex 视图',
    previewLoadHead: '加载文件头部',
    previewLoadTail: '加载文件尾部',
    previewLoadNext: '加载下一段',
    previewFitToScreen: '适配屏幕',
    previewActualSize: '实际大小',
    previewZoomOut: '缩小',
    previewZoomIn: '放大',
    previewLoadingImage: '正在加载图片',
    previewFailedFile: '加载文件内容失败：{message}',
    previewFailedFileShort: '加载文件内容失败。',
    previewFailedImage: '加载图片内容失败：{message}',
    previewFailedImageShort: '加载图片内容失败。',
    previewFailedMore: '加载更多内容失败：{message}',
    previewFailedMoreShort: '加载更多内容失败。',
    previewFailedImagePreview: '图片预览加载失败。',
    previewTryHex: '尝试切换到 Hex 视图查看数据。',
    previewHexTruncated: '\n... 输出已截断（显示 {shown} / {total}） ...',
    previewEncodingUnsupported: '编码 {encoding} 不支持，已回退到 UTF-8。',
    previewBinaryNotSupported: '二进制文件无法预览。',
    previewDownloadFile: '下载文件',
    previewImagePlaceholder: '图片预览占位',
    editBinaryNotSupported: '无法编辑二进制文件。',
    editBinaryOrImageNotSupported: '无法编辑二进制或图片文件。',
    editSavingUsesUtf8: '保存使用 UTF-8 编码',
    editLoadFailed: '加载文件失败。',
    editSaveFailed: '保存文件失败。',
    editSave: '保存',
    editSaving: '保存中...',
    editUndo: '撤销 (Ctrl+Z)',
    editRedo: '重做 (Ctrl+Y)',
    editFind: '查找 (Ctrl+F)',
    editToggleWrap: '切换自动换行',
    editZoomOut: '缩小',
    editZoomIn: '放大',
    clipboardTitle: '远程剪贴板文件',
    clipboardQueue: '队列中还有 {count} 个任务',
    clipboardEmpty: '暂无可下载的文件',
    clipboardPreparing: '打包中...',
    clipboardReceived: '已接收 {size}',
    clipboardCancel: '取消下载',
    clipboardDownloaded: '已下载',
    clipboardPendingCalc: '待计算',
    clipboardFileFallback: '文件',
    clipboardMoreItems: ' 等 {count} 项',
    clipboardAddQueue: '添加到下载队列',
    clipboardDownloadItem: '下载此项',
    clipboardDownloadAll: '全部打包下载',
    clipboardAddToQueue: '添加到队列',
    clipboardItemsCount: '（{count} 项）',
    clipboardDownloadFailed: '下载失败: {message}',
    loadingMore: '正在加载更多...',
    showingFiles: '显示 {shown} / {total} 个文件',
    totalFiles: '共 {count} 个文件',
    // Search Engine Init
    commandSearchEngine: '文件搜索引擎',
    commandSearchEngineInitTitle: '初始化文件搜索引擎',
    searchEngineInitTitle: '初始化文件搜索引擎',
    searchEngineReinitTitle: '重新初始化搜索引擎',
    searchEngineSelectDrives: '请选择要建立索引的磁盘（NTFS格式）：',
    searchEngineLoadingDrives: '正在获取可用磁盘...',
    searchEngineLoadDrivesFailed: '获取磁盘列表失败',
    searchEngineSelectAtLeastOne: '请至少选择一个磁盘',
    searchEngineInitFailed: '初始化失败',
    searchEngineSelectAll: '全选',
    searchEngineDeselectAll: '取消全选',
    searchEngineFree: '可用',
    searchEngineTotal: '总计',
    searchEngineLocalDisk: '本地磁盘',
    searchEngineNoDrives: '未找到可用的 NTFS 磁盘',
    searchEngineInitButton: '开始初始化',
    searchEngineReinitButton: '重新初始化',
    searchEngineStatusScanning: '扫描中...',
    searchEngineStatusBuilding: '构建索引...',
    searchEngineStatusCalculating: '计算大小',
    searchEngineStatusInitializing: '初始化中...',
  },
  en: {
    rootLabel: 'This PC',
    quickAccess: 'Quick Access',
    unpinQuickAccess: 'Unpin from Quick access',
    pinQuickAccess: 'Pin to Quick access',
    network: 'Network',
    empty: 'Empty',
    loading: 'Loading...',
    noSubfolders: 'No subfolders',
    selectFolder: 'Select Folder',
    cancel: 'Cancel',
    confirm: 'Confirm',
    name: 'Name',
    type: 'Type',
    size: 'Size',
    dateModified: 'Date modified',
    diskUsage: 'Disk %',
    parentPercent: 'Folder %',
    percentPendingInit: 'Pending',
    percentInitializing: 'Init...',
    fileCount: 'Files',
    na: 'N/A',
    file: 'File',
    folder: 'Folder',
    drive: 'Drive',
    devicesAndDrives: 'Devices and drives',
    driveFree: 'free',
    driveTotal: 'of',
    driveLoading: 'Loading...',
    fileFolder: 'File folder',
    movingItems: 'Moving {count} items',
    downloadFailed: 'Download failed: {message}',
    downloadStart: 'Downloading {count} items...',
    loadingFiles: 'Loading {loaded}/{total}',
    pathCopied: 'Path copied to clipboard',
    linkCopied: 'Link copied to clipboard',
    unzipFailed: 'Unzip failed: {message}',
    extractSuccess: 'Extracted to: {path}',
    // File share
    shareTitle: 'Share Files',
    shareFileCount: '{count} file(s) selected',
    sharePassword: 'Access password',
    sharePasswordPlaceholder: 'Leave blank for no password',
    shareMaxDownloads: 'Max downloads',
    shareMaxDownloadsPlaceholder: 'Leave blank for unlimited',
    shareExpiry: 'Expiry',
    shareExpiryDuration: 'Duration',
    shareExpiryDate: 'Expiry date',
    shareDurationValue: 'Duration',
    shareUnitHour: 'Hours',
    shareUnitDay: 'Days',
    shareSubmit: 'Generate link',
    shareSubmitting: 'Generating...',
    shareResultTitle: 'Share link generated',
    shareLinkWithPassword: 'Link with password',
    shareLinkNoPassword: 'Link without password',
    shareCopy: 'Copy',
    shareCopied: 'Copied',
    shareCopyAll: 'Copy all',
    shareDone: 'Done',
    shareFailed: 'Share failed: {message}',
    shareInvalidDuration: 'Please enter a valid duration',
    shareInvalidDate: 'Please select a valid expiry date',
    renameFailed: 'Rename failed',
    pasteFailed: 'Paste failed',
    deleteConfirm: 'Delete {count} item(s)?',
    deleteConfirmNonEmptySingle: 'Delete {count} item(s)?\n\nNote: {names} is a non-empty folder and will be deleted with all contents.',
    deleteConfirmNonEmptyMultiple: 'Delete {count} item(s)?\n\nNote: {names} are non-empty folders and will be deleted with all contents.',
    deleteFailed: 'Failed to delete {count} item(s):\n{details}',
    exceedsBatchLimit: 'Exceeds 10GB limit',
    fileTooLarge: 'File too large (>2GB)',
    newFolder: 'New folder',
    extractTo: 'Extract to...',
    commandGlobalSearchTitle: 'Global File Search (Ctrl+Shift+F)',
    commandSearchAllFiles: 'Search All Files',
    commandFilter: 'Filter',
    commandRegex: 'Use Regular Expression',
    commandMatchCase: 'Match Case',
    commandMatchWholeWord: 'Match Whole Word',
    commandGridView: 'Grid view',
    commandDetailsView: 'Details view',
    commandTreemapView: 'Space analysis',
    spaceAnalysisTitle: 'Disk Space Analysis',
    spaceAnalysisNeedEngine: 'Space analysis needs the file index to be ready',
    spaceAnalysisEmpty: 'Nothing to show in this folder',
    spaceAnalysisLoading: 'Analyzing…',
    treemapOtherHint: 'Click to view details',
    contextLocateInRemote: 'Locate on remote desktop',
    contextOpenInRemote: 'Open on remote desktop',
    contextRemoteLocateMultiConfirm: 'Locate {count} items on the remote desktop one by one. Continue?',
    contextRemoteOpenMultiConfirm: 'Open {count} items on the remote desktop one by one. Continue?',
    treemapLocateInManager: 'Locate in file manager',
    treemapLocateInRemote: 'Locate on remote desktop',
    treemapDelete: 'Delete',
    spaceListTitle: '{name} · Children',
    spaceListSummary: '{count} items · {size}',
    spaceListMoreOmitted: '{count} smaller items ({size}) not listed',
    fileCountCol: '{count} files',
    fileCountColHeader: 'Files',
    commandUploadFile: 'Upload file',
    commandUploadFolder: 'Upload folder',
    commandUploadManager: 'Upload Manager',
    commandOpenNewWindow: 'Open in new window',
    commandClose: 'Close',
    contextNewFolder: 'New folder',
    contextPaste: 'Paste',
    contextSortBy: 'Sort by',
    contextSortName: 'Name',
    contextSortType: 'Type',
    contextSortSize: 'Size',
    contextSortDate: 'Date',
    contextSortAsc: 'Ascending',
    contextSortDesc: 'Descending',
    contextDownloadZip: 'Download as Zip',
    contextDownload: 'Download',
    contextShare: 'Share',
    contextPreview: 'Preview',
    contextEdit: 'Edit',
    contextExtract: 'Extract...',
    contextExtractHere: 'Extract Here',
    contextExtractTo: 'Extract to...',
    contextPin: 'Pin to Quick access',
    contextUnpin: 'Unpin from Quick access',
    contextRename: 'Rename',
    contextCopy: 'Copy',
    contextCut: 'Cut',
    contextCopyPath: 'Copy Path',
    contextDelete: 'Delete',
    contextUploadHere: 'Upload here',
    contextUploadFile: 'Upload files',
    contextUploadFolder: 'Upload folder',
    searchPlaceholder: 'Search all files...',
    searchMode: 'Mode:',
    searchPrefix: 'Prefix',
    searchContains: 'Contains',
    searchPrefixHint: '(faster, matches beginning)',
    initializedVolumes: 'Indexed:',
    searchContainsHint: '(slower, matches anywhere)',
    searchInitializing: 'File search engine is initializing, please wait...',
    searchContainsMinChars: 'Contains mode requires at least 3 characters',
    searchFailed: 'Search failed',
    searchInitializingHint: 'First run needs indexing. Please wait...',
    searchNoResults: 'No results found',
    searchMinChars: 'Type at least 2 characters to search',
    searchGoToFolder: 'Go to folder',
    searchResultsCount: '{count} results',
    searchResultsHint: 'Click or press Enter on result to navigate',
    conflictTitle: 'File Conflict',
    conflictMessage: 'The destination already has a file named "{name}".',
    conflictExisting: 'Existing file',
    conflictQuestion: 'What would you like to do?',
    conflictReplace: 'Replace the file',
    conflictReplaceDesc: 'Overwrite existing file with the new one',
    conflictRename: 'Rename the new file',
    conflictRenameDesc: 'Keep both files (append number)',
    conflictSkip: 'Skip this file',
    conflictSkipDesc: 'Do not copy/upload this file',
    conflictApplyAll: 'Do this for all conflicts',
    conflictOverwriteAll: 'Overwrite All',
    conflictRenameAll: 'Rename All',
    conflictSkipAll: 'Skip All',
    uploadTitle: 'Uploads',
    uploadCurrent: 'Current',
    uploadHistory: 'History',
    uploadAllComplete: 'All uploads complete',
    uploadNoHistory: 'No history',
    uploadClearHistory: 'Clear History',
    uploadBatch: 'Batch {id}',
    uploadRetryBatch: 'Retry Batch',
    uploadCancelBatch: 'Cancel Batch',
    uploadMoreItems: '... and {count} more items',
    uploadCancelTitle: 'Cancel Upload Batch?',
    uploadCancelDesc: 'Do you want to delete the files that have already been uploaded successfully?',
    uploadCancelYesDelete: 'Yes, delete uploaded files',
    uploadCancelNoKeep: 'No, keep uploaded files',
    uploadCancelContinue: 'Cancel (Continue Upload)',
    previewHex: 'Hex',
    previewHead: 'Head',
    previewTail: 'Tail',
    previewMore: 'More ({size})',
    previewLoading: 'Loading...',
    previewFit: 'Fit',
    previewEncodingFallback: 'Encoding fallback',
    previewPartial: 'Partial',
    previewPartialTip: 'Preview is partial',
    previewToggleHex: 'Toggle Hex View',
    previewLoadHead: 'Load file head',
    previewLoadTail: 'Load file tail',
    previewLoadNext: 'Load next chunk',
    previewFitToScreen: 'Fit to screen',
    previewActualSize: 'Actual size',
    previewZoomOut: 'Zoom out',
    previewZoomIn: 'Zoom in',
    previewLoadingImage: 'Loading image',
    previewFailedFile: 'Failed to load file content: {message}',
    previewFailedFileShort: 'Failed to load file content.',
    previewFailedImage: 'Failed to load image content: {message}',
    previewFailedImageShort: 'Failed to load image content.',
    previewFailedMore: 'Failed to load more content: {message}',
    previewFailedMoreShort: 'Failed to load more content.',
    previewFailedImagePreview: 'Failed to load image preview.',
    previewTryHex: 'Try Hex view to inspect data.',
    previewHexTruncated: '\n... Output truncated (showing {shown} of {total}) ...',
    previewEncodingUnsupported: 'Encoding {encoding} not supported, fallback to UTF-8.',
    previewBinaryNotSupported: 'Preview not available for binary files.',
    previewDownloadFile: 'Download File',
    previewImagePlaceholder: 'Image preview placeholder',
    editBinaryNotSupported: 'Cannot edit binary files.',
    editBinaryOrImageNotSupported: 'Editing is not available for binary or image files.',
    editSavingUsesUtf8: 'Saving uses UTF-8',
    editLoadFailed: 'Failed to load file.',
    editSaveFailed: 'Failed to save file.',
    editSave: 'Save',
    editSaving: 'Saving...',
    editUndo: 'Undo (Ctrl+Z)',
    editRedo: 'Redo (Ctrl+Y)',
    editFind: 'Find (Ctrl+F)',
    editToggleWrap: 'Toggle Word Wrap',
    editZoomOut: 'Zoom Out',
    editZoomIn: 'Zoom In',
    clipboardTitle: 'Remote Clipboard Files',
    clipboardQueue: '{count} tasks in queue',
    clipboardEmpty: 'No downloadable files',
    clipboardPreparing: 'Packaging...',
    clipboardReceived: 'Received {size}',
    clipboardCancel: 'Cancel download',
    clipboardDownloaded: 'Downloaded',
    clipboardPendingCalc: 'Calculating',
    clipboardFileFallback: 'File',
    clipboardMoreItems: ' and {count} more',
    clipboardAddQueue: 'Add to download queue',
    clipboardDownloadItem: 'Download this item',
    clipboardDownloadAll: 'Download all as Zip',
    clipboardAddToQueue: 'Add to queue',
    clipboardItemsCount: '({count} items)',
    clipboardDownloadFailed: 'Download failed: {message}',
    loadingMore: 'Loading more...',
    showingFiles: 'Showing {shown} / {total} files',
    totalFiles: '{count} files total',
    // Search Engine Init
    commandSearchEngine: 'Search Engine',
    commandSearchEngineInitTitle: 'Initialize File Search Engine',
    searchEngineInitTitle: 'Initialize File Search Engine',
    searchEngineReinitTitle: 'Reinitialize Search Engine',
    searchEngineSelectDrives: 'Select drives to index (NTFS only):',
    searchEngineLoadingDrives: 'Loading available drives...',
    searchEngineLoadDrivesFailed: 'Failed to load drive list',
    searchEngineSelectAtLeastOne: 'Please select at least one drive',
    searchEngineInitFailed: 'Initialization failed',
    searchEngineSelectAll: 'Select All',
    searchEngineDeselectAll: 'Deselect All',
    searchEngineFree: 'free',
    searchEngineTotal: 'total',
    searchEngineLocalDisk: 'Local Disk',
    searchEngineNoDrives: 'No NTFS drives found',
    searchEngineInitButton: 'Start Initialization',
    searchEngineReinitButton: 'Reinitialize',
    searchEngineStatusScanning: 'Scanning...',
    searchEngineStatusBuilding: 'Building index...',
    searchEngineStatusCalculating: 'Calculating sizes',
    searchEngineStatusInitializing: 'Initializing...',
  },
} as const;

type TranslationKey = keyof typeof translations.zh;

const resolveLang = (value?: string | null): Lang => {
  const normalized = (value || '').trim().toLowerCase();
  if (!normalized) return DEFAULT_LANG;
  if (normalized.startsWith('en')) return 'en';
  return 'zh';
};

export const getLang = (): Lang => {
  if (typeof window === 'undefined') return DEFAULT_LANG;
  const params = new URLSearchParams(window.location.search);
  return resolveLang(params.get('lang'));
};

export const t = (key: TranslationKey, params?: Record<string, string | number>) => {
  const lang = getLang();
  const table = translations[lang] || translations[DEFAULT_LANG];
  let value = table[key] || translations[DEFAULT_LANG][key] || key;
  if (!params) return value;
  Object.entries(params).forEach(([token, replacement]) => {
    value = value.replace(new RegExp(`\\{${token}\\}`, 'g'), String(replacement));
  });
  return value;
};

export const getRootLabel = () => t('rootLabel');

export const normalizeRootInput = (input: string) => {
  const trimmed = input.trim();
  if (!trimmed) return input;
  const labels = Object.values(ROOT_LABELS);
  const matched = labels.some(label => label.toLowerCase() === trimmed.toLowerCase());
  return matched ? 'root' : input;
};
